<template>
  <button
    type="button"
    class="bg-transparent border-0 cursor-pointer"
    :class="variantClass"
    @click="$emit('click')"
  >
    <img :src="iconSrc" alt="Back" class="drop-shadow-[0_1px_8px_rgba(12,12,13,0.16)]" />
  </button>
</template>

<script>
import platformMixin from '@/mixins/platformMixin';

export default {
  name: 'BackButton',
  mixins: [platformMixin],
  props: {
    // 'inline'   → occupies layout space (pt gutter), for plain-top pages
    // 'floating' → absolute, sits over a hero/banner (needs a relative ancestor)
    // 'bare'     → no positioning; the parent supplies it via class
    variant: {
      type: String,
      default: 'inline',
    },
    // orange chevron for GIC conference context
    isGic: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    iconSrc() {
      return this.isGic
        ? require('../../../public/assets/icons/go-back-chevron-orange.svg')
        : require('../../../public/assets/icons/go-back-chevron.svg');
    },
    variantClass() {
      if (this.variant === 'floating') {
        return ['p-0 absolute left-[24px] z-10', this.isIos ? 'top-[60px]' : 'top-[16px]'];
      }
      if (this.variant === 'bare') {
        return ['p-0'];
      }
      // inline (default) — mb-[24px] is the standard gap below the back button
      return ['block px-[24px] pb-0 mb-[24px]', this.isIos ? 'pt-[60px]' : 'pt-[16px]'];
    },
  },
};
</script>
